export const THEME_COLORS = {
  light: {
    about_details_card: "rgb(242,242,247)",
    full_theme: "#fff",
    inverse_theme: "#000",
    inverse_less_theme: "#101010",
    less_theme: "rgb(242,242,247)",
    purple: "#7930A2",
    green: "#25D366",
    grey: "lightgray",
    blue: "rgb(0,122,255)",
    less_blue: "rgba(0,122,255,0.6)",
    less_white: "rgba(255,255,255,0.25)",
    gold: "#f1c40c",
    red: "red",
    component_background_color: "#fff",
    page_background_color: "rgb(242,242,247)",
    component_more_light_background_color: "rgb(58,58,60)",
    white: "#fff",
    orange: "orange",
    piPurple: "#9b51e0",
    pink: "#FF69B4",
    gray: "gray",
  },
  dark: {
    gray: "gray",
    piPurple: "#9b51e0",
    white: "#fff",
    about_details_card: "#101010",
    full_theme: "#000",
    inverse_theme: "#fff",
    inverse_less_theme: "rgb(242,242,247)",
    less_white: "rgba(255,255,255,0.25)",

    less_theme: "rgb(58,58,60)",
    purple: "#A594FD",
    green: "#25D366",
    grey: "lightgray",
    blue: "rgb(0,122,255)",
    less_blue: "rgba(0,122,255,0.6)",
    gold: "#f1c40c",
    red: "red",
    component_background_color: "rgb(28,28,30)",
    page_background_color: "#000",
    component_more_light_background_color: "rgb(58,58,60)",
    orange: "orange",
    pink: "#FF69B4",
  },
};
